import { useTopicsDataContext } from "app/pages/activation/context/Topics/TopicsDataContext";
import { useTopicsModalContext } from "app/pages/activation/context/Topics/TopicsModalContext";
import { translate } from "app/filters/i18nFilter";
import * as SC from "app/pages/activation/components/Topics/Modal/styles";
import { MODAL_TEXTS } from "app/pages/activation/components/Topics/texts";
import type { TopicSchema } from "app/pages/activation/components/Topics/types";

import { deleteTopicFlowKeys } from "./automationKeys";
import { getButtonsConfig } from "./buttonsConfig";
import DeleteButtons from "./DeleteButtons";
import type { DeleteTopicsFlowSchema } from "./types";

export const DeleteTopicsFlow = ({ topicId, isShared, onDelete }: DeleteTopicsFlowSchema) => {
    const { createdTopics } = useTopicsDataContext();

    const topicToDelete = createdTopics.find((topic: TopicSchema) => topic.topicId === topicId);

    const { onClose } = useTopicsModalContext();

    const secondButtonConfig = isShared
        ? { ...getButtonsConfig().cancel, onClick: onClose }
        : { ...getButtonsConfig().deleteTopicWithKW, onClick: () => onDelete(topicId, true) };

    return (
        <>
            <SC.StyledHeader data-automation={deleteTopicFlowKeys.header}>
                <SC.StyledTitle data-automation={deleteTopicFlowKeys.title}>
                    {translate(MODAL_TEXTS.titleDelete)}
                </SC.StyledTitle>
            </SC.StyledHeader>

            <SC.StyledBody data-automation={deleteTopicFlowKeys.body}>
                <SC.StyledBodyText>
                    {isShared
                        ? translate(MODAL_TEXTS.bodyDeleteShared, { name: topicToDelete?.topicName })
                        : translate(MODAL_TEXTS.bodyDelete, { name: topicToDelete?.topicName })}
                </SC.StyledBodyText>
            </SC.StyledBody>

            <DeleteButtons
                config={{
                    cancel: {
                        ...getButtonsConfig().cancel,
                        onClick: onClose,
                        isVisible: !isShared,
                    },
                    deleteTopicWithKW: {
                        ...secondButtonConfig,
                        isVisible: true,
                    },
                    deleteTopic: {
                        ...getButtonsConfig().deleteTopic,
                        onClick: () => onDelete(topicId, false),
                    },
                }}
            />
        </>
    );
};
